import { createContext, useContext } from 'react';
import type { User, Session } from '@supabase/supabase-js';

export type OrgIdStatus = 'idle' | 'loading' | 'ready' | 'error' | 'no-membership';

export type SignupMetadata = {
  full_name: string;
  id_passport_number: string;
  identity_document_type: 'sa_id' | 'foreign_passport';
  cell_number: string;
};

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  orgId: string | null;
  orgIdStatus: OrgIdStatus;
  signIn: (email: string, password: string) => Promise<{ error: any }>;
  signUp: (
    email: string,
    password: string,
    metadata: SignupMetadata
  ) => Promise<{ error: any; user: User | null }>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

// Helper to check if org context is ready for secure operations
export const useOrgReady = () => {
  const { orgIdStatus } = useAuth();
  return orgIdStatus === 'ready';
};
